var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFranceFlag = function SvgFranceFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "144.5 696.5 300 200",
    xmlSpace: "preserve"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ED2939",
    d: "M144.5 696.5h300v200h-300z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M144.5 696.5h200v200h-200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M144.5 696.5h100v200h-100z"
  })))));
};
export default SvgFranceFlag;